import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Hero from "@/components/Hero";
import { ArticleCard } from "@/components/ArticleCard";
import { Manifesto, EditorialMarquee } from "@/components/Manifesto";
import Newsletter from "@/components/Newsletter";
import LaunchingSoon from "@/components/LaunchingSoon";
import ShortsReel from "@/components/ShortsReel";
import { fetchArticles } from "@/lib/api";

export default function Home() {
  const [articles, setArticles] = useState([]);
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchArticles()
      .then(setArticles)
      .finally(() => setLoading(false));
    fetchArticles({ category: "video", limit: 12 })
      .then(setVideos)
      .catch(() => {});
  }, []);

  if (loading) {
    return (
      <div className="pt-48 pb-40 flex flex-col items-center gap-4">
        <div className="w-10 h-10 rounded-full bg-[#FFD400] animate-pulse flex items-center justify-center font-editorial font-black text-[#0D0D10]">ख</div>
        <span className="font-mono-meta text-xs text-slate-500 uppercase tracking-widest">लोड हो रहा है...</span>
      </div>
    );
  }

  const featured = articles.find((a) => a.featured) || articles[0];
  const rest = articles.filter((a) => a.id !== featured?.id);
  const bulletin = [...articles].sort((a, b) => b.views - a.views);

  if (articles.length === 0) {
    return (
      <main className="pt-28" data-testid="home-page">
        <LaunchingSoon />
      </main>
    );
  }

  return (
    <main className="pt-28 lg:pt-28" data-testid="home-page">
      <Hero featured={featured} bulletin={bulletin} />

      <ShortsReel videos={videos} />

      <section className="max-w-7xl mx-auto px-4 sm:px-6 mt-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex items-end justify-between mb-8"
        >
          <div>
            <span className="font-mono-meta text-xs text-[#FFD400] uppercase tracking-[0.3em]">ताज़ा खबरें</span>
            <h2 className="font-display text-3xl sm:text-4xl text-white mt-2">आज की सुर्खियाँ</h2>
          </div>
          <span className="font-mono-meta text-xs text-slate-500 hidden sm:block">{rest.length} लेख</span>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {rest.slice(0, 6).map((a, i) => (
            <ArticleCard key={a.id} article={a} index={i} />
          ))}
        </div>
      </section>

      <EditorialMarquee />

      <section className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {rest.slice(6).map((a, i) => (
            <ArticleCard key={a.id} article={a} index={i} />
          ))}
        </div>
      </section>

      <Manifesto />

      <Newsletter />
    </main>
  );
}
